import { DSButton } from '@engenharia/ds-react';
import { useTranslation } from 'react-i18next';
import { BiRightArrowAlt } from 'react-icons/bi';

import Button from '../atoms/Button';

import { Action, Container } from './styles';

export default function Footer({
  activeStep,
  listStep,
  onGoNext,
  onGoBack,
  loading,
  isPartner,
  disabled,
}) {
  const { t } = useTranslation();
  const isLastStep = activeStep === listStep.length - 1;

  const setLabelButton = (step) => {
    const labels = {
      0: 'settings.steps.aboutYou.button',
      1: 'settings.steps.profiles.button',
      2: 'settings.steps.welcome.button',
      default: '',
    };

    if (isPartner) {
      return t(labels[2]);
    }

    return t(labels[step] || labels.default);
  };

  return (
    <Container>
      <Action>
        {!!onGoBack && activeStep !== 0 && (
          <DSButton className="outline" disabled={loading} onClick={onGoBack} variant="outline">
            {t('button.back')}
          </DSButton>
        )}
        {activeStep !== listStep.length && (
          <Button
            className={isLastStep ? 'green-button' : ''}
            disabled={disabled || loading}
            onClick={onGoNext}
            endIcon={<BiRightArrowAlt />}
          >
            {setLabelButton(activeStep)}
          </Button>
        )}
      </Action>
    </Container>
  );
}
